import * as React from 'react';
const SvgTelegram = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" fill="none" {...props}>
        <path d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.337 13.852c4.082-1.778 6.803-2.95 8.165-3.517 3.888-1.617 4.695-1.898 5.222-1.907.116-.002.375.027.543.163a.59.59 0 01.199.379c.019.109.042.357.023.551-.21 2.214-1.122 7.586-1.586 10.065-.196 1.05-.583 1.401-.957 1.436-.813.075-1.43-.537-2.218-1.054-1.232-.807-1.928-1.31-3.124-2.098-1.382-.911-.486-1.412.302-2.23.206-.214 3.788-3.472 3.857-3.768.009-.037.017-.175-.065-.247s-.203-.048-.29-.029c-.123.029-2.092 1.33-5.905 3.904-.559.383-1.065.57-1.518.56-.5-.01-1.462-.282-2.176-.515-.877-.285-1.574-.435-1.513-.92.031-.251.378-.51 1.041-.773z"
            fill="#fff"
        />
    </svg>
);
export default SvgTelegram;
